import React from "react";

const ReferencesSingleSelect = props => {
  const calculatedWidth = {
    width: `${100 / props.options.length}%`
  };

  return (
    <div className="reference-single-select">
      <div className={props.bold ? "font-weight-bold" : ""}>
        {" "}
        {props.description}{" "}
      </div>{" "}
      <div className="d-none d-sm-block">
        <div className="btn-group" role="group">
          {" "}
          {props.options.map((option, i) => (
            <button
              key={i}
              type="button"
              style={calculatedWidth}
              className={
                props.value === option
                  ? "btn text-capitalize btn-secondary"
                  : "btn text-capitalize btn-outline-secondary"
              }
              value={option}
              name={props.name}
              onClick={props.onSelect}
            >
              {option}{" "}
            </button>
          ))}{" "}
        </div>{" "}
      </div>{" "}
      <div className="d-sm-none">
        <div className="btn-group-vertical" role="group">
          {" "}
          {props.options.map((option, i) => (
            <button
              key={i}
              type="button"
              className={
                props.value === option
                  ? "btn text-capitalize btn-secondary"
                  : "btn text-capitalize btn-outline-secondary"
              }
              value={option}
              name={props.name}
              onClick={props.onSelect}
            >
              {option}{" "}
            </button>
          ))}{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

export default ReferencesSingleSelect;
